import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Scrollbar, Mousewheel } from "swiper";

const ThumbGallerySwiper = (props) => {
  const { smallThumbs, imageAlt, isImageOnly, scrollbar, mousewheel } = props;
  return isImageOnly ? (
    <img
      className="image-thumb-image-only"
      src={smallThumbs?.length > 0 ? smallThumbs[0] : null}
      alt={!!imageAlt ? imageAlt : "no title"}
    />
  ) : (
    <Swiper
      className="big-thumb-gallery swiper-generic-style"
      slidesPerView={1}
      centeredSlides={true}
      navigation={true}
      loop={true}
      preventClicks={true}
      preventClicksPropagation={true}
      pagination={{
        dynamicBullets: true,
      }}
      allowTouchMove={false}
      scrollbar={scrollbar}
      mousewheel={mousewheel}
      modules={[Pagination, Navigation, Scrollbar, Mousewheel]}
    >
      {smallThumbs?.map((thumb, index) => {
        if (thumb?.trim() === "") return null;
        return (
          <SwiperSlide key={index}>
            <img src={thumb} alt={imageAlt} 
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default ThumbGallerySwiper;
